<div *ngIf="!isLoading && !failedResult" id="verifast-verify-container">
    <app-verifast-iframe
    [setfailedResult]="setfailedResult"
    [setIsLoadingFunc]="setIsLoading"
    [getVerifastUrl]="getVerifastUrl"
    [iFrameURL]="iFrameURL"
    ></app-verifast-iframe>
</div>
<div *ngIf="isLoading" class="flex justify-center"><mat-progress-spinner
        mode="indeterminate"></mat-progress-spinner>
</div>